import { useTolgee } from '@tolgee/react';
import { useEffect } from 'react';

import { DefaultLocale, localeOptions } from '../providers/tolgee';
import useAccessBadge from './useAccessBadge';

export function useLocale() {
  const tolgee = useTolgee();
  const { accessBadge, isFetched, isSuccess, isFetching } = useAccessBadge();
  const preferredLocale = accessBadge?.user.preferredLocale ?? getPreferredLocale();
  const matchingLocale = getAvailableLocaleFromCode(preferredLocale);
  useEffect(() => {
    if (
      ((isFetched && !isFetching) || (!isSuccess && !isFetching)) &&
      matchingLocale !== tolgee.getLanguage()
    ) {
      tolgee.changeLanguage(matchingLocale ?? DefaultLocale);
      storePreferredLocale(matchingLocale ?? DefaultLocale);
    }
  }, [isFetched, isSuccess, isFetching, matchingLocale, tolgee]);
}

function getPreferredLocale() {
  return localStorage.getItem('curipod.preferredLocale') ?? getLang();
}

export function storePreferredLocale(locale: string) {
  localStorage.setItem('curipod.preferredLocale', locale);
}

export function getLang() {
  if (navigator.languages !== undefined) return navigator.languages[0];
  return navigator.language;
}

export function getAvailableLocaleFromCode(code: string) {
  const lowerCasedCode = code.toLowerCase();
  const matchingLocale = localeOptions.find(
    ([value]) =>
      value.toLowerCase().startsWith(lowerCasedCode) ||
      lowerCasedCode.startsWith(value.toLowerCase()),
  )?.[0];
  if (matchingLocale) {
    return matchingLocale;
  }

  if (lowerCasedCode.length > 2) {
    return localeOptions.find(([value]) =>
      value.toLowerCase().startsWith(lowerCasedCode.slice(0, 2)),
    )?.[0];
  }
  return undefined;
}
